"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _types = require("../../types");

var _GenderMale = _interopRequireDefault(require("../../../../../../icons-react/userflow/GenderMale"));

var _GenderFemale = _interopRequireDefault(require("../../../../../../icons-react/userflow/GenderFemale"));

var _GenderUnidentified = _interopRequireDefault(require("../../../../../../icons-react/userflow/GenderUnidentified"));

var _ICONS_MAP;

var ICONS_MAP = (_ICONS_MAP = {}, (0, _defineProperty2["default"])(_ICONS_MAP, _types.GenderEnum.MALE, _GenderMale["default"]), (0, _defineProperty2["default"])(_ICONS_MAP, _types.GenderEnum.FEMALE, _GenderFemale["default"]), (0, _defineProperty2["default"])(_ICONS_MAP, _types.GenderEnum.UNKNOWN, _GenderUnidentified["default"]), _ICONS_MAP);

var GenderIcon = function GenderIcon(props) {
  var className = props.className,
      type = props.type;
  var element = ICONS_MAP[type];

  if (!element) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(element, {
    className: className
  });
};

var _default = /*#__PURE__*/_react["default"].memo(GenderIcon);

exports["default"] = _default;